import {faPenToSquare} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import Button from 'components/Button';
import DeleteButton from 'components/Button/Delete';
import EditControls from 'components/Edit/EditControls';
import MultiSelectFilter, {multiselectOrFilter} from 'components/Table/Filter/MultiSelect';
import TextFilter from 'components/Table/Filter/Text';
import VirtualizedTable from 'components/Table/Virtualized';
import {fixedColumnStyle} from 'components/Table/columnHelpers';
import Tag from 'components/Tag';
import {TechStackStyles} from 'conf/techStackColors';



export default function TechStackList({techStacks, onEdit, onSuccess, onFailure}) {

  const renderControlCell = ({value}) => (
    <EditControls className="editControls--inline">
      <DeleteButton
        url={`api/v1/techStacks/${value}`}
        id={value}
        onSuccess={onSuccess}
        onFailure={onFailure}
        iconOnly={true}
      />
      <Button
        key={`edit${value}`}
        data-id={value}
        actionHandler={onEdit}
        className="btn-warning"
        iconOnly={true}
        title="Edit"
      >
        <FontAwesomeIcon icon={faPenToSquare} />
      </Button>
    </EditControls>
  );

  return (
    <VirtualizedTable
      data={techStacks}
      columns={[
        {
          id: 'Controls',
          Header: 'Controls',
          accessor: 'techStackId',
          Cell: renderControlCell,
          ...fixedColumnStyle(100),
        },
        {
          id: 'category',
          Header: 'Category',
          accessor: 'category',
          Filter: MultiSelectFilter,
          filter: multiselectOrFilter,
          sortable: true,
        },
        {
          id: 'name',
          Header: 'Tech Stack Name',
          accessor: 'techStackName',
          Filter: TextFilter,
          Cell: renderTechStackCell,
          sortable: true,
        },
      ]}
    />
  );
}

export function renderTechStackCell({value}) {
  if (!value) {
    return null;
  }
  return <Tag style={TechStackStyles[value]}>{value}</Tag>;
}
